import { Component, EventEmitter, Output, Inject, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslateService } from '@services/translate.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { depositConfigItemType, withdrawConfigItemType } from '@sharedTemplates/deposit/Deposit.module';
import { PayoutDialog } from '@components/payout.dialog';
import { environment } from '@environments/environment';
import { WithdrawService } from '@sharedTemplates/withdraw/Withdraw.service';

@Component({
  selector: 'withdraw-additional-info.component',
  templateUrl: './withdrawAdditionalInfo.dialog.html',
})
export class WithdrawAdditionalInfoDialog implements AfterViewInit {
  WithdrawFormDatas: UntypedFormGroup;

  WithdrawFormRaw: any;
  @Output() dataChangedCallback = new EventEmitter<any>();
  bankList: { BankId: number; Bank: string }[] = [];

  constructor(
    public dialogRef: MatDialogRef<WithdrawAdditionalInfoDialog>,
    private _FormBuilder: UntypedFormBuilder,
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    public _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _TranslateService: TranslateService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    public _WithdrawService: WithdrawService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      configItem: withdrawConfigItemType;
      amount: string;
      WithdrawTypeId: string;
      PaymentType: string;
      minValue: string;
      maxValue: string;
    }
  ) {
    if (this.data.configItem.additionalInfo.includes('de_phoneNumber')) {
      this.WithdrawFormDatas = _FormBuilder.group({
        withdrawamount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
        phoneNumber: new UntypedFormControl({ value: '', disabled: false }, [Validators.minLength(10), Validators.maxLength(15), Validators.required]),
        transactionTypeId: new UntypedFormControl({ value: '' }),
      });
    }
    if (this.data.configItem.additionalInfo.includes('email_address')) {
      this.WithdrawFormDatas = _FormBuilder.group({
        withdrawamount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
        mailadress: new UntypedFormControl({ value: '', disabled: false }, [Validators.required, Validators.email]),
        transactionTypeId: new UntypedFormControl({ value: '' }),
      });
    } else if (this.data.configItem.additionalInfo.includes('bankList')) {
      this.WithdrawFormDatas = _FormBuilder.group({
        bankList: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
        accountNo: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
        nameSurname: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
        banksAmount: new UntypedFormControl({ value: '', disabled: false }, [Validators.required]),
      });
    }
  }

  ngAfterViewInit() {
    if (this.data.configItem.additionalInfo.includes('bankList')) {
      this.WithdrawBanks();
      this._UiHelper.setNavbarTitle('Withdraw', true);
      if (this._UiHelper.rightMenu) {
        this._UiHelper.setRightMenu();
      }
    } else if (this.data.configItem.additionalInfo.includes('email_address') || this.data.configItem.additionalInfo.includes('de_phoneNumber')) {
      this._UiHelper.setNavbarTitle('withdrawReq', true);
    }
  }

  openPayoutDialog(): void {
    const dialogRef = this.dialog.open(PayoutDialog, {
      width: environment.mobile ? '340px' : '500px',
      height: environment.mobile ? '345px' : '240px',
    });
    dialogRef.afterClosed().subscribe(result => {
      // //console.log('The dialog was closed',result);
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  WithdrawBanks() {
    this._ApiService.getWithdrawBanks().then(result => {
      this.bankList = result;
    });
  }
}
